import { useRef, useState } from 'react';

const SWIPE_TRIGGER = 90;
const LONG_PRESS_MS = 500;
const DOUBLE_TAP_MS = 300;
const MOVE_TOLERANCE = 10;

const isExcluded = (el) => !!el.closest('button, input, select, [data-no-gesture]');

// Touch gestures for a bar row: swipe left, long-press, double-tap.
export function useBarGestures({ onSwipeLeft, onLongPress, onDoubleTap }) {
  const [offset, setOffset] = useState(0);
  const g = useRef({ lastTap: 0 });

  const clearTimer = () => { clearTimeout(g.current.timer); g.current.timer = null; };

  const onPointerDown = (e) => {
    if (e.pointerType === 'mouse' || isExcluded(e.target)) return;
    g.current = { ...g.current, active: true, x: e.clientX, y: e.clientY, mode: null, fired: false };
    g.current.timer = setTimeout(() => {
      g.current.fired = true;
      g.current.active = false;
      navigator.vibrate?.(30);
      onLongPress();
    }, LONG_PRESS_MS);
  };

  const onPointerMove = (e) => {
    const s = g.current;
    if (!s.active) return;
    const dx = e.clientX - s.x;
    const dy = e.clientY - s.y;
    if (!s.mode && (Math.abs(dx) > MOVE_TOLERANCE || Math.abs(dy) > MOVE_TOLERANCE)) {
      clearTimer();
      s.mode = Math.abs(dx) > Math.abs(dy) ? 'swipe' : 'scroll';
    }
    if (s.mode === 'swipe') setOffset(Math.min(0, Math.max(-140, dx)));
  };

  const onPointerUp = (e) => {
    const s = g.current;
    clearTimer();
    if (!s.active) return;
    s.active = false;
    if (s.mode === 'swipe') {
      if (e.clientX - s.x < -SWIPE_TRIGGER) onSwipeLeft();
      setOffset(0);
      return;
    }
    if (s.mode || s.fired) return;
    const now = Date.now();
    if (now - s.lastTap < DOUBLE_TAP_MS) {
      s.lastTap = 0;
      onDoubleTap();
    } else {
      s.lastTap = now;
    }
  };

  const onPointerCancel = () => { clearTimer(); g.current.active = false; setOffset(0); };

  return { offset, handlers: { onPointerDown, onPointerMove, onPointerUp, onPointerCancel } };
}
